/// <reference path="App.ts" />
namespace HA.Core.HTML.App {
    export class Search extends App {

        protected createSelf() {
            super.createSelf();
        }
    }
}
